import { useContext } from "react";
import { TranslationsContext } from "../providers/translations";

const useTranslate = () => {
  const { translate } = useContext(TranslationsContext);
  return translate;
};

export default useTranslate;
